module.exports = __webpack_public_path__ + "img/question.369c96b5.svg";